import * as ActionTypes from "../constants/actionTypes"
import { IOngoingDoctorConsultation } from "../interfaces/ongoingConsultation/IOngoingDoctorConsultation"
import { OngoingDoctorConsultationActionNames } from "../constants/actionTypes"

function init(): any {
	return {}
}

export const sectionSuggestionReducer = (state = init(), action: any): any => {
	switch (action.type) {
		case ActionTypes.UPDATE_SUBSECTION_SUGGESTIONS:
			return {
				...state,
				...action.payload,
			}
		default:
			return state
	}
}
